import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 9F794864-D790-48F3-A8B4-31AEC3BB17FD
 * name arrow-collapse-left
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse-left.svg
 * tags
 * - Arrow 
 */
export const ArrowCollapseLeftIcon = createSvgIcon(<><path d="M11.92,19.92L4,12L11.92,4.08L13.33,5.5L7.83,11H22V13H7.83L13.34,18.5L11.92,19.92M4,12V2H2V22H4V12Z" /></>, 'ArrowCollapseLeftIcon');
export default ArrowCollapseLeftIcon